// extracted by mini-css-extract-plugin
export var closeButton = "_49-0";